/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { userListConfig } from '../../config/missingInfo.config';
import { StorageModule } from '@vlinder-web/storage-module-react';
import moment from 'moment-timezone';
import { toHeaderCase } from 'js-convert-case';
import { Graphql } from '@common/graphql';
import { vappContainer } from '@/application';
import { apiConfig } from '@/config/apiConfig';
import { AppNavigatorService } from '@/AppNavigator/services';
import { GET_MISSING_INFO } from '../../api/graphql';
import { APPLICATION_TYPE } from '@/config/applicationType.config';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};
export interface IMissingInfoMethods extends IPluginMethodMap {
  getMissingInfo(args: any): Promise<any>;
}

export class MissingInfoService implements IAgentPlugin {
  readonly methods: IMissingInfoMethods;

  constructor() {
    this.methods = {
      getMissingInfo: this.getMissingInfo.bind(this),
    };
  }

  private async getMissingInfo(args: any) {
    const storageService = StorageModule.getInstance();
    const _localData = storageService.get('userProfile', 'local');
    const _sessionData = storageService.get('userProfile', 'session');
    const userProfile = storageService.get('myProfile', 'session');
    const role = userProfile?.org?.orgRole;
    const roetable = [
      {
        column: 'type',
        op: 'In',
        value: ['CARICOM_RENEW_WORK_PERMIT','CARICOM_NEW_WORK_PERMIT','NEW_RIGHTS_OF_ESTABLISHMENT'],
      },
    ];
    const userData = _sessionData ?? _localData;
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      const token = loginSrv()?.getToken();
      console.log(`getUserListsProps service token`, token);
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      if (client) {
        const res = await client.query(GET_MISSING_INFO, {
          input: {
            skip: args?.offset,
            limit: args?.size,
            where: [
              ...(args?.where ?? []),
              ...(role === 'CARICOM_BUSSINESS_ORG' ? roetable : []),
              {
                column: 'status',
                op: 'In',
                value: ['MISSING_INFORMATION', 'DOCUMENTATION_REJECTED'],
              },
            ],
            order: [
              {
                column: 'updatedAt',
                direction: 'DESC',
              },
            ],
          },
        });
        if (res?.data) {
          console.log(`table data`, res);
          let _rowData = this.formatUserTable(
            res?.data?.getListOfApplication?.data
          );
          console.log(`row data`, _rowData);
          return {
            ...userListConfig,
            ultUsers: _rowData,
            userRoles: res?.data?.getRoleList?.data,
            isEmpty: _rowData
              ? res?.data?.getListOfApplication?.data?.length <= 0
              : true,
            // studentGroup: holderGroups,
            activePage: res?.data?.getListOfApplication?.currentPage,
            pageSize: res?.data?.getListOfApplication?.pageSize,
            totalCount: res?.data?.getListOfApplication?.totalCount,
            totalPages: res?.data?.getListOfApplication?.totalPages,
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      throw err;
    }
  }

  private formatUserTable(data: any) {
    let _rowData: any =
      Array.isArray(data) &&
      data.map((item: any, index: number) => {
        return {
          id: item?.applicationNo,
          // status: item?.status,
          name: item?.applicantInfo?.firstName
            ? ` ${
                item?.applicantInfo?.lastName
                  ? toHeaderCase(item?.applicantInfo?.lastName ?? '')
                  : ''
              }, ${toHeaderCase(item?.applicantInfo?.firstName)} ${
                item?.applicantInfo?.middleName
                  ? toHeaderCase(item?.applicantInfo?.middleName ?? '')
                  : ''
              }`
            : '',

          appliedOn: this.formatCreatedDate(item?.createdAt),
          status: this.getFormattedStatus(item?.status),
          applicationId: item?.applicationNo,
          type: this.getFormattedType(item?.type),
          nationality: item?.applicantInfo?.nationality ?? '-',
          comment: item?.comment,
          // comment: "testcomment from service"
        };
      });

    return _rowData;
  }

  private formatCreatedDate(date: Date) {
    if (date) {
      return moment(date).format('LLL');
    }
  }

  private getFormattedType(type: string) {
    if (APPLICATION_TYPE?.[type]) {
      return APPLICATION_TYPE?.[type];
    }
    return '-';
  }

  private getFormattedStatus(status: string) {
    if (status) {
      switch (status) {
        case 'MISSING_INFORMATION':
          return 'Missing Information';
        case 'DOCUMENTATION_REJECTED':
          return 'Documentation Rejected';
        case 'READY_TO_PAY':
          return 'Ready to Pay';
        case 'APP_FEES_PAID':
          return 'Application Fees Paid';
        case 'SUBMITTED':
          return 'Submitted';
        case 'REVIEWED':
          return 'Reviewed';
        case 'APPROVED':
          return 'Approved';
        case 'WP_FEES_PAID':
          return 'Work Permit Fees Paid';

        default:
          return '-';
      }
    }
  }
}
